import { render, staticRenderFns } from "./list.vue?vue&type=template&id=5f47fc3a&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=5f47fc3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../空降-sp-弯弯介绍的/kj-德语-源码/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f47fc3a",
  null
  
)

export default component.exports